<div class="modal fade termination-modal" [id]="modalId" tabindex="-1" aria-hidden="true"
    data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered termination-modal-dialog">
        <div class="modal-content termination-modal-content">
            <button type="button" class="termination-close-btn" (click)="cancel()" aria-label="Cerrar">
                <i class="ti ti-x"></i>
            </button>

            <h4 class="termination-title">Registro de baja</h4>
            <p class="termination-subtitle">
                Ingresa la siguiente información para realizar el registro de baja del colaborador{{employeeName ? ' ' + employeeName : ''}}
            </p>

            <form [formGroup]="form" (ngSubmit)="confirm()">
                <div class="termination-columns">
                    <div class="termination-col">
                        <div class="termination-field">
                            <label class="termination-label">Fecha de baja</label>
                            <input type="date" class="termination-input"
                                [class.is-invalid]="submitted && f['termination_date'].invalid"
                                formControlName="termination_date">
                            <div class="termination-error" *ngIf="submitted && f['termination_date'].invalid">
                                La fecha de baja es obligatoria
                            </div>
                        </div>

                        <div class="termination-field">
                            <label class="termination-label">Tipo de baja</label>
                            <select class="termination-select"
                                [class.is-invalid]="submitted && f['termination_type'].invalid"
                                formControlName="termination_type">
                                <option value="" disabled>Seleccionar</option>
                                <option *ngFor="let type of terminationTypes" [value]="type">{{type}}</option>
                            </select>
                            <div class="termination-error" *ngIf="submitted && f['termination_type'].invalid">
                                El tipo de baja es obligatorio
                            </div>
                        </div>

                        <div class="termination-field">
                            <label class="termination-label">Motivo de baja</label>
                            <select class="termination-select"
                                [class.is-invalid]="submitted && f['termination_reason'].invalid"
                                formControlName="termination_reason">
                                <option value="" disabled>Seleccionar</option>
                                <option *ngFor="let reason of terminationReasons" [value]="reason">{{reason}}</option>
                            </select>
                            <div class="termination-error" *ngIf="submitted && f['termination_reason'].invalid">
                                El motivo de baja es obligatorio
                            </div>
                        </div>

                        <div class="termination-field">
                            <label class="termination-label">Comentarios</label>
                            <textarea class="termination-textarea" formControlName="comments"
                                placeholder="Ingresa comentarios adicionales"></textarea>
                        </div>
                    </div>

                    <div class="termination-col">
                        <div class="termination-field">
                            <label class="termination-label termination-label-sm">Selecciona los días laborados</label>
                            <div class="termination-calendar">
                                <div class="termination-calendar-month">
                                    <span class="termination-calendar-month-label">{{monthLabel}}</span>
                                    <div class="termination-calendar-nav">
                                        <button type="button" class="termination-calendar-nav-btn" (click)="prevMonth()" aria-label="Mes anterior">
                                            <i class="ti ti-chevron-left"></i>
                                        </button>
                                        <button type="button" class="termination-calendar-nav-btn" (click)="nextMonth()" aria-label="Mes siguiente">
                                            <i class="ti ti-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                                <hr class="termination-calendar-divider">
                                <div class="termination-calendar-weekdays">
                                    <span *ngFor="let wd of weekdayLabels">{{wd}}</span>
                                </div>
                                <div class="termination-calendar-week" *ngFor="let week of calendarWeeks">
                                    <button type="button" *ngFor="let cell of week" class="termination-calendar-day"
                                        [class.is-empty]="!cell" [class.is-selected]="isSelected(cell)"
                                        [disabled]="!cell" (click)="toggleDay(cell)">
                                        {{cell?.day}}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="termination-field">
                            <label class="termination-label termination-label-sm">Total días laborados</label>
                            <input type="number" min="0" class="termination-input" formControlName="total_worked_days">
                        </div>
                    </div>
                </div>

                <div class="termination-actions">
                    <button type="button" class="termination-btn termination-btn-secondary" (click)="cancel()">Cancelar</button>
                    <button type="submit" class="termination-btn termination-btn-primary" *ngIf="canDo('Dar de baja')"
                        [class.is-disabled-look]="isRegisterDisabledLook">Registrar baja</button>
                </div>
            </form>
        </div>
    </div>
</div>
